import _classCallCheck from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import BearishEngulfingPattern from "./BearishEngulfingPattern";
import BearishHammerStick from "./BearishHammerStick";
import BearishHarami from "./BearishHarami";
import BearishHaramiCross from "./BearishHaramiCross";
import BearishInvertedHammerStick from "./BearishInvertedHammerStick";
import BearishMarubozu from "./BearishMarubozu";
import CandlestickFinder from "./CandlestickFinder";
import EveningDojiStar from "./EveningDojiStar";
import EveningStar from "./EveningStar";
import HangingMan from "./HangingMan";
import HangingManUnconfirmed from "./HangingManUnconfirmed";
import ShootingStar from "./ShootingStar";
import ShootingStarUnconfirmed from "./ShootingStarUnconfirmed";
import ThreeBlackCrows from "./ThreeBlackCrows";
import TweezerTop from "./TweezerTop";
var bearishPatterns = [new BearishEngulfingPattern(), new BearishHarami(), new BearishHaramiCross(), new EveningDojiStar(), new EveningStar(), new BearishMarubozu(), new ThreeBlackCrows(), new BearishHammerStick(), new BearishInvertedHammerStick(), new HangingMan(), new HangingManUnconfirmed(), new ShootingStar(), new ShootingStarUnconfirmed(), new TweezerTop()];

var BearishPatterns =
/*#__PURE__*/
function (_CandlestickFinder) {
  _inherits(BearishPatterns, _CandlestickFinder);

  function BearishPatterns() {
    var _this;

    _classCallCheck(this, BearishPatterns);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BearishPatterns).call(this));
    _this.name = "Bearish Candlesticks";
    return _this;
  }

  _createClass(BearishPatterns, [{
    key: "hasPattern",
    value: function hasPattern(data) {
      return bearishPatterns.reduce(function (state, pattern) {
        return state || pattern.hasPattern(data);
      }, false);
    }
  }]);

  return BearishPatterns;
}(CandlestickFinder);

export { BearishPatterns as default };
export function bearish(data) {
  return new BearishPatterns().hasPattern(data);
}